import {
    call,
    fork,
    put,
    takeLatest,
} from 'redux-saga/effects';
import {
    dashboardSettingsGet,
    defaultEditorPut
} from '@/services/ElasticApi';
import {
    GetDashboardSettingsError,
    GetDashboardSettingsSuccess,
    SetDefaultEditorError,
    SetDefaultEditorSuccess
} from '@/store/dashboardSettings/actions';
import {
    DashboardSettingsActionTypes,
    SetDefaultEditorAction,
} from '@/store/dashboardSettings/types';
import { ShowToast } from '@/store/toast/actions';
import i18n from '@/../i18n';
import { errorToast } from './commonGenerators/errorToast';


function* getDashboardSettingsSaga(): any {
    try {
        const dashboardSettings = yield call(dashboardSettingsGet);
        yield put(GetDashboardSettingsSuccess(dashboardSettings.data));
    } catch (e) {
        yield call(errorToast, e);
        yield put(GetDashboardSettingsError());
    }
}
function* watchGetDashboardSettingsSaga(): any {
    yield takeLatest(DashboardSettingsActionTypes.GET_DASHBOARD_SETTINGS, getDashboardSettingsSaga);
}
function* setDefaultEditorSaga(action: SetDefaultEditorAction): any {
    try {
        const { payload } = action;
        yield call(defaultEditorPut, payload.defaultEditor );
        yield put(SetDefaultEditorSuccess());
        if (!payload.showSuccessToast) return;
        yield put(
            ShowToast({
                message: i18n.t('settingsupdated'),
                severity: 'success',
                duration: 5000,
            })
        );
    } catch (e) {
        yield call(errorToast, e);
        yield put(SetDefaultEditorError());
    }
}
function* watchSetDefaultEditorSaga(): any {
    yield takeLatest(DashboardSettingsActionTypes.SET_DEFAULT_EDITOR, setDefaultEditorSaga);
}

const dashboardSettingsSagas = [
    fork(watchGetDashboardSettingsSaga),
    fork(watchSetDefaultEditorSaga)
];

export default dashboardSettingsSagas;
